<template>
    <ActionDialog
        v-model="show_message_dialog"
        :show_header="false"
        @after-leave="after_leave"
    >
        <template #content>
            <div class="d-flex align-center justify-space-between px-6 pt-4">
                <div class="text-h6 medium">
                    {{ translate(title) }}
                </div>
            </div>
            <div class="text-subtitle-2 px-6 pt-2">
                {{ translate(text) }}
            </div>
            <div class="d-flex pt-2 px-6 pb-4">
                <v-spacer />
                <v-btn
                    @click="close_dialog"
                    color="primary"
                    variant="flat"
                >
                    {{ translate('common.close') }}
                </v-btn>
            </div>
        </template>
    </ActionDialog>
</template>

<script>
import { mapActions } from 'vuex'
import { api_mixin } from '@old/mixins/api_mixin'
import { locales_mixin } from '@old/mixins/locales_mixin'
import ActionDialog from '@old/components/action_dialog/index.vue'

export default {
    name: 'MessageDialog',
    props: {
        title: String,
        text: String,
    },
    mixins: [api_mixin, locales_mixin],
    components: { ActionDialog },
    data() {
        return {
            show_message_dialog: false,
        }
    },
    computed: {},
    methods: {
        async close_dialog() {
            this.show_message_dialog = false
        },
        async after_leave() {
            await this.set_state_property({
                property: 'message_dialog',
                data: null,
            })
        },
        ...mapActions(['set_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        this.show_message_dialog = true
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
